exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-resource-name{padding:3px 15px 3px 5px}.report-resource-leader{height:25px}\n", ""]);

// exports
